import React from "react";
import { Item as DropdownPrimitiveItem } from "@radix-ui/react-dropdown-menu";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";

DropdownItem.propTypes = {
    children: PropTypes.node.isRequired,
    asChild: PropTypes.bool,
    onClick: PropTypes.func,
    onSelect: PropTypes.func,
    className: PropTypes.string,
};

export default function DropdownItem({ children, onSelect, className, onClick }) {
    return (
        <DropdownPrimitiveItem
            // we pass onClick as well to be able to block event propagation in
            // the bubbling phase ( target to root direction of propagation ),
            // needed for clickable items in the listing which could be a parent to this instance of dropdown
            onClick={onClick}
            asChild
            onSelect={onSelect}
            className={twMerge(
                cc(["block", "px-4", "py-2", "text-sm", "text-gray-700", "outline-none", "cursor-pointer", className]),
            )}>
            <li>{children}</li>
        </DropdownPrimitiveItem>
    );
}
